import React, { Component } from 'react';
import {Icon} from "@blueprintjs/core";

class CostBreakdownLinesTable extends Component {

    render() {
        return (this.props.costBreakdownLines.size > 0
                ? (
                    <table className="table">
                        <thead>
                        <tr className="d-flex">
                            <th className="col-2 " style={{borderBottom: 'none'}}>Producto</th>
                            {/*<th className="col-2 " style={{borderBottom: 'none'}}>Proveedor</th>*/}
                            <th className="col-3" style={{borderBottom: 'none'}}>Comentarios</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Cantidad</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Precio</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right', minWidth: 120}}>Descuento (%)</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>CNC</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Total</th>
                            <th className="col-1 " style={{borderBottom: 'none'}}></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.costBreakdownLines.map((line, i) => {
                            return (
                                <tr className="d-flex" key={line.get('_id')} >
                                    <td className="col-2">{line.getIn(['product', 'name'])}</td>
                                    {/*<td className="col-2">{line.getIn(['supplier', 'basic_info', 'name'])}</td>*/}
                                    <td className="col-3">{line.get('comments')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('amount')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('price')}</td>
                                    <td className="col" style={{ textAlign: 'right', minWidth: 120 }} >{line.get('discount')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('cnc')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('total')}</td>
                                    <td className="col-1 d-flex justify-content-center">
                                        { this.props.editMode
                                            ? <Icon
                                                className="cursor-pointer"
                                                icon="trash"
                                                title="Eliminar"
                                                style={{marginLeft: 0}}
                                                onClick={() => this.props.deleteLine(i) }
                                            /> : null
                                        }
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                ) : 'No hay lineas de escandallo.'
        );
    }

}

export default CostBreakdownLinesTable;


// WEBPACK FOOTER //
// ./src/components/common/CostBreakdownLinesTable.js